import i18nStrings from "../strings/stings";
import api from "../api";

export const emailErrorMessage = async (email) => {
  const strings = i18nStrings;
  try {
    await api.validationEmail(email);
    return "";
  } catch (error: any) {
    if (error && error.response.data.error) {
      switch (error.response.data.error) {
        case "email_invalid_domain":
          return strings.emailsCannotBe;
        case "email_forbidden":
          return strings.doNotUse;
        case "email_is_in_black_list":
          return strings.inABlackList;
        default:
          return strings.enterTheEmail;
      }
    }
  }
  return strings.enterTheEmail;
};
